import stringify from "fast-json-stable-stringify";

// Pulled from Lodash for toPath
// https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/.internal/stringToPath.js#L3-L17

const charCodeOfDot = ".".charCodeAt(0);
const reEscapeChar = /\\(\\)?/g;
const rePropName = RegExp(
  // Match anything that isn't a dot or bracket.
  "[^.[\\]]+" +
    "|" +
    // Or match property names within brackets.
    "\\[(?:" +
    // Match a non-string expression.
    "([^\"'][^[]*)" +
    "|" +
    // Or match strings (supports escaping characters).
    "([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2" +
    ")\\]" +
    "|" +
    // Or match "" as the space between consecutive dots or empty brackets.
    "(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))",
  "g",
);

/**
 * Converts `string` to a property path array.
 *
 * Pulled from Lodash
 */
const toPath = (string: string): Array<string> => {
  const result = [];
  if (string.charCodeAt(0) === charCodeOfDot) {
    result.push("");
  }
  string.replace(rePropName, (match, expression, quote, subString) => {
    let key = match;
    if (quote) {
      key = subString.replace(reEscapeChar, "$1");
    } else if (expression) {
      key = expression.trim();
    }
    result.push(key);
    // unused, we only care about result accumulator mutated above
    return "";
  });
  return result;
};

/**
 * Deeply get a value from an object via its path.
 *
 * Pulled from Formik
 */
export function getIn(obj: any, key: string) {
  let pathIndex = 0;
  const path = toPath(key);
  while (obj && pathIndex < path.length) {
    obj = obj[path[pathIndex++]];
  }
  return obj;
}

/** Returns whether two objects are equal. Stringifies objects under the hood. */
export const isEqual = (
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>,
) => {
  return stringify(obj1) === stringify(obj2);
};
